let originalDatepickerUi;
let lastTrigger = null;
let gformDialogListenerBound = false;

window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('dialog .close-popup').forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const popupId = this.getAttribute('data-popup-id');
            if (popupId) {
                closeDialog(popupId + 'Popup');
            }
        });
    });

    document.addEventListener("click", function (event) {
        // Resolve the nearest anchor from the click target
        const link = event.target.tagName === "A"
            ? event.target
            : event.target.closest("a");

        if (!link) return;

        const clickedHref = link.getAttribute("href");

        // Guard: no href or not a dialog trigger
        if (!clickedHref || !clickedHref.includes("Popup")) return;

        const targetDialog = document.querySelector(clickedHref);

        if (!targetDialog) {
            console.warn("No dialog with selector: " + clickedHref);
            return;
        }

        event.preventDefault();
        lastTrigger = link;
        targetDialog.setAttribute('aria-modal', 'true');
        targetDialog.setAttribute('role', 'dialog');
        targetDialog.setAttribute('tabindex', '-1');
        targetDialog.showModal();
        targetDialog.focus({ preventScroll: true });

        const dialogVideo = targetDialog.querySelector("video");
        if (dialogVideo) dialogVideo.play();

        const dialogForm = targetDialog.querySelector('.gform_wrapper form');
        if (dialogForm) {
            handleDialogDatepicker(targetDialog);

            // Bind gform_page_loaded once across all dialog opens
            if (typeof jQuery !== 'undefined' && !gformDialogListenerBound) {
                jQuery(document).on('gform_page_loaded', function () {
                    const openDialog = document.querySelector('dialog[open]');
                    if (openDialog) handleDialogDatepicker(openDialog);
                });
                gformDialogListenerBound = true;
            }
        }

        // { once: true } prevents listeners from stacking on repeated opens
        targetDialog.addEventListener("click", function (e) {
            if (e.target === targetDialog) closeDialog(targetDialog);
        }, { once: true });

        targetDialog.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                e.preventDefault();
                closeDialog(targetDialog);
            }
        }, { once: true });
    });
});

// Gform Datepicker UI Fix
function handleDialogDatepicker(dialog) {
    const dialogForm = dialog.querySelector('.gform_wrapper form');
    if (!dialogForm) return;

    const dialogFormDatepickerInputs = dialogForm.querySelectorAll('input.hasDatepicker');
    if (!dialogFormDatepickerInputs.length) return;

    originalDatepickerUi = document.querySelector('#ui-datepicker-div');

    dialogFormDatepickerInputs.forEach((input) => {
        input.addEventListener('focus', function () {
            const datepickerUi = document.querySelector('#ui-datepicker-div');

            const inputRect = input.getBoundingClientRect();
            const datePickerHeight = datepickerUi.offsetHeight;
            const availableSpaceBelow = window.innerHeight - inputRect.bottom;
            const availableSpaceAbove = inputRect.top;

            if (availableSpaceBelow >= datePickerHeight) {
                datepickerUi.style.top = `${inputRect.bottom}px`;
            } else if (availableSpaceAbove >= datePickerHeight) {
                datepickerUi.style.top = `${inputRect.top - datePickerHeight - 20}px`;
            }

            dialog.appendChild(datepickerUi);
        });
    });
}

function closeDialog(dialog) {
    if (typeof dialog === 'string') {
        dialog = document.getElementById(dialog);
    }

    if (!dialog) {
        console.warn("Dialog element not found");
        return;
    }

    const dialogVideo = dialog.querySelector("video");
    const dialogForm  = dialog.querySelector('.gform_wrapper form');

    dialog.classList.add("hideDialog");

    // { once: true } replaces the manual removeEventListener(arguments.callee) pattern;
    // animationend replaces the vendor-prefixed webkitAnimationEnd
    dialog.addEventListener("animationend", function () {
        dialog.classList.remove("hideDialog");
        dialog.close();

        if (dialogVideo) dialogVideo.pause();

        if (
            (dialogForm || dialog.querySelector('.gform_confirmation_wrapper')) &&
            originalDatepickerUi &&
            !document.querySelector('body > #ui-datepicker-div')
        ) {
            document.querySelector('body').appendChild(originalDatepickerUi);
        }

        if (lastTrigger) {
            lastTrigger.focus({ preventScroll: true });
            lastTrigger = null;
        }
    }, { once: true });
}

